import type { JSX } from "react";
import { useTranslation } from "react-i18next";
import { ImageUp } from "lucide-react";

/**
 * Akce „Nastavit jako hlavní“ na náhledu fotky galerie (vize podnety-tymu-2026-10, F7.12;
 * řez 05, Kontrakt bod 3). Umisťuje se sama (`absolute bottom-1 right-1`): levý dolní roh
 * `SortableThumb` nese pořadí náhledu, levý horní úchyt, pravý horní odebrání. Háček
 * `[data-gallery-set-primary]` s `data-media-id`.
 *
 * Vzhled a skrývání jako úchyt řazení (`group` nese kořen `SortableThumb`), navíc viditelná při
 * fokusu klávesnicí. Ikona `ImageUp`, ne `Star`: ★ v knihovně znamená „dobrá fotka“. Posluchače
 * dnd-kit tlačítko nenese, klik proto řazení nespustí. Pravidlo galerie je `setGalleryPrimary`
 * (`galleryPrimary.ts`), volá ho rodič v `onSetPrimary`.
 */
export default function GalleryPrimaryAction({
  mediaId,
  onSetPrimary,
}: {
  mediaId: string;
  onSetPrimary: (id: string) => void;
}): JSX.Element {
  const { t } = useTranslation();
  const label = t("mediaPicker.primary.setPrimary");
  return (
    <button
      type="button"
      className="absolute bottom-1 right-1 rounded bg-white/90 p-1 text-gray-600 opacity-0 shadow transition-opacity focus-visible:opacity-100 group-hover:opacity-100 dark:bg-gray-800/90 dark:text-gray-300"
      data-gallery-set-primary=""
      data-media-id={mediaId}
      title={label}
      aria-label={label}
      onClick={() => onSetPrimary(mediaId)}
    >
      <ImageUp className="h-3.5 w-3.5" />
    </button>
  );
}
